export const getPoster = (posterImage, thumbnails, containerWidth) => {
  let poster;

  if (posterImage) {
    return posterImage;
  }

  // default thumbnail
  if (thumbnails.length > 0) {
    poster = thumbnails[thumbnails.length - 1];
  }

  containerWidth &&
    thumbnails?.forEach((thumbnail) => {
      if (!poster || thumbnail.width > containerWidth) {
        poster = thumbnail;
      }
    });

  return poster ? poster.source : null;
};
